export const locale = {
  lang: 'en-US',
  data: {},
};
